import BrandsPage from 'src/dispensary/brands';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';

BrandsPage.layout = MainDispensaryLayout;
export default BrandsPage;
